export const columns = [
  {
    Header: 'Nivel',
    accessor: 'category',
  },
  {
    Header: 'Imagen',
    accessor: 'image',
  },
  {
    Header: 'Editar',
    accessor: 'editCardCategory',
  },
  {
    Header: 'Eliminar',
    accessor: 'deleteCardCategory',
  },
  {
    Header: 'Estado',
    accessor: 'active',
  },
]